import React from 'react';
import { css } from '@emotion/core';
import FrameSlider from 'components/common/FrameSlider';
import { below } from 'utils/breakpoint';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';

function SliderAndShowFrame({
    style,
    frameList,
    frameUrl,
    setFrameUrl,
    setFrameUuid = () => {},
    enableFixedFrameHeight,
    customImgContainerCss,
    customImgCss,
    needHandleClick = false,
    handleClick,
    isShowPlayIcon = false
}) {
    const countFrameItems = frameList.length;

    return (
        <div css={[uploadFrameContainerStyle, css(style)]}>
            <div
                css={[imgContainerCss(enableFixedFrameHeight), customImgContainerCss]}
                onClick={needHandleClick ? handleClick : () => {}}
            >
                <img src={frameUrl} alt="" css={[frameUrlCss, customImgCss]} />
                {isShowPlayIcon && <PlayCircleFilledWhiteIcon css={playIconStyle} />}
            </div>
            {countFrameItems > 1 && (
                <FrameSlider
                    frameSize={80}
                    frameList={frameList}
                    onFrameClick={({ uuid, value }) => {
                        setFrameUrl(value);
                        setFrameUuid(uuid);
                    }}
                />
            )}
        </div>
    );
}

export default SliderAndShowFrame;

const uploadFrameContainerStyle = css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const imgContainerCss = enableFixedFrameHeight => css`
    width: 414px;
    height: ${Boolean(enableFixedFrameHeight) ? '414px' : '100%'};
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    position: relative;
`;

const frameUrlCss = css`
    max-width: 382px;
    max-height: 382px;
    ${below('xsm')} {
        max-width: 367px;
        max-height: 367px;
    }
`;

const playIconStyle = css`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    max-width: 53px;
    max-height: 53px;
    color: #ffffff;
    width: 100%;
    height: 100%;
`;
